

























import Vue from "vue"
import PSampleProfile from "../../../../guideline/util/PSampleProfile.vue"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import { DESCRIPTION_ICON } from "~/config/icon"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"

export default Vue.extend({
  components: {
    SectionTitle,
    RowGroup,
    ColumnWithIcon,
    EditItemDescription,
    PSampleProfile,
  },
  props: {
    selfIntroduction: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        description: DESCRIPTION_ICON,
      },
      sampleText: `■サンプル①
新卒で株式会社●●にて法人営業に従事、その後経営企画室に異動になり5年間新規事業開発に携わりました。
その後SaaSのベンチャー企業に転職し、COOとして事業推進に関わり3年で売上規模を1億⇒5億に成長させました。
コアスキルとして、市場調査からのプロダクト企画、組織マネジメントを得意としております。

■サンプル②
大学在学中から情報技術を学び、新卒で●●株式会社にてWebアプリケーションのフロントエンドを経験しました。
その後フリーランスに転身し、Webアプリケーション開発をメインとしてバックエンドやネットワークなどの各フェーズの実務経験を積んでいます。
開発規模としては20名まで、要件定義から運用保守まで経験しております。`,
    }
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }
      return "/profiles/edit/self_introduction"
    },
  },
})
